import moment from "moment/moment";
import React, { useEffect, useState } from "react";
import { Container, Modal } from "react-bootstrap";
import Flatpickr from "react-flatpickr";
import { Controller, useForm } from "react-hook-form";
import * as XLSX from "xlsx";
import {
  editVol,
  fetchMasterOnClientLocation,
  getOldVol,
  saveNewPreviewChartsInDB,
} from "../../../services/managerService";
import "../ManagerWorklistDetails.css";

const WorklistEditVol = ({ worklistDetail, masterData, onSuccess }) => {
  const [showModalBox, setShowModalBox] = useState(false);
  const [showPreviewModalBox, setShowPreviewModalBox] = useState(false);
  const [selectSpecialtyId, setSelectSpecialtyId] = useState();
  const [desiredClient, setDesiredClient] = useState({});
  const [desiredProcess, setDesiredProcess] = useState({});
  const [desiredSpeciality, setDesiredSpeciality] = useState({});
  const [desiredLocation, setDesiredLocation] = useState({});
  const [excelSheetData, updateExcelSheetData] = useState([]);
  const [oldVol, setOldVol] = useState([]);
  const [isLoading, setLoadingState] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isExcelUpload, setIsExcelUpload] = useState(false);

  const options = {
    maxDate: new Date(),
    dateFormat: "m/d/Y",
  };

  options.maxDate.setDate(options.maxDate.getDate() + 1);

  // const optionsDS = {
  //   maxDate: new Date(),
  //   dateFormat: "m/d/Y",
  // };

  const {
    register,
    control,
    getValues,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    setDesiredClient(
      masterData?.clients.find(
        (client) => client.name === worklistDetail?.client,
      ),
    );
    setDesiredSpeciality(
      masterData?.specialties.find(
        (speciality) => speciality.name === worklistDetail?.specialty,
      ),
    );

    setDesiredProcess(
      masterData?.processes.find(
        (process) => process.name === worklistDetail?.process,
      ),
    );
    setDesiredLocation(
      masterData?.locations.find(
        (location) => location.name === worklistDetail?.location,
      ),
    );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [masterData]);

  const handleFileUpload = async (e) => {
    try {
      const file = e.target.files[0];
      const data = await file.arrayBuffer();
      const workbook = XLSX.read(data);
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      let jsonData = XLSX.utils.sheet_to_json(worksheet, {
        header: 1,
        defval: "",
        raw: false,
      });
      jsonData = jsonData.filter((row) => !row.every((cell) => cell === ""));
      setIsExcelUpload(true);
      updateExcelSheetData(jsonData);
    } catch (error) {
      console.log(error);
    }
  };

  const registerOptions = {
    worklist_no: {
      required: "Required",
      pattern: { value: /^\S/, message: "Invalid input" },
      maxLength: { value: 15, message: "EsetValues(eeded max limit" },
    },
    no_of_charts: {
      required: "Required",
      pattern: { value: /^-?\d+$/, message: "Invalid input" },
      max: { value: 99999, message: "EsetValues(eeded max limit" },
      min: { value: 1, message: "Invalid input" },
    },
    date_of_service: { required: "Required" },
    SpecialtyId: { required: "Required" },
    received_date: { required: "Required" },
  };

  const handlePreview = async (e) => {
    e.preventDefault();
    setShowModalBox(false);
    setShowPreviewModalBox(true);

    const oldCharts = await getOldVol(worklistDetail?.id);
    setOldVol(oldCharts.data);
  };

  const handleSubmitPreview = async (e) => {
    e.preventDefault();
    try {
      setLoadingState(true);
      const data = {
        worklist_no: getValues("worklist_no") || worklistDetail?.worklist_no,
        ClientId: getValues("ClientId") || desiredClient?.id,
        ProcessId: getValues("ProcessId") || desiredProcess?.id,
        LocationId: getValues("LocationId") || desiredLocation?.id,
        date_of_service:
          getValues("date_of_service") || worklistDetail?.date_of_service,
        Speciality: getValues("SpecialtyId") || desiredSpeciality?.id,
        received_date:
          getValues("received_date") || worklistDetail?.received_date,
        no_of_charts: getValues("no_of_charts") || worklistDetail?.no_of_charts,
        excelSheetData: excelSheetData || [],
      };
      const response = await editVol(data, worklistDetail?.id);

      if (response?.success === true) {
        window.toastr.success("Worklist volume edited successfully");
        onSuccess();
        setShowModalBox(false);
      } else {
        window.toastr.error(response?.message || "Something went wrong!");
      }
      setLoadingState(false);
    } catch (e) {
      console.log(e);
      window.toastr.error(e.message || "Something went wrong!!");
      setLoadingState(false);
    }
  };

  const fetchClientLocationMaster = async (cID) => {
    const response = await fetchMasterOnClientLocation(cID, "");
    setSelectSpecialtyId(response?.specialties);
    setIsLoaded(true);
  };

  useEffect(() => {
    if (desiredClient?.id) {
      fetchClientLocationMaster(desiredClient?.id);
    }
  }, [desiredClient]);

  function identifyNewChartsFromExistingCharts(
    existingCharts,
    completeChartList,
  ) {
    const mergedChartList = completeChartList.slice(1).map((chart, idx) => {
      const trimmedChartNo = chart[0]?.replaceAll("0000", "");

      const existingChart = existingCharts.find(
        (eChart) => eChart.chart_no === trimmedChartNo,
      );
      const existingChartIdx = existingCharts.findIndex(
        (eChart) => eChart.chart_no === trimmedChartNo,
      );

      return {
        chart_no: chart[0],
        mr_no: chart[1],
        date_of_service: chart[2],
        admit_date: chart[3],
        discharge_date: chart[4],
        id: existingChart?.id,
        isNew: !existingChart,
        currentIdx: idx + 1,
        existingIdx: existingChartIdx,
      };
    });

    return mergedChartList;
  }

  function rowClassName(isNew) {
    return isNew ? "align-middle table-success" : "align-middle";
  }

  function renderUploadedChartListViewList(oldVol, excelSheetData) {
    const charts = identifyNewChartsFromExistingCharts(oldVol, excelSheetData);
    return charts.map((item, index) => {
      return (
        <tr key={index} className={rowClassName(item.isNew)}>
          <td>{item.chart_no}</td>
          <td>{item.mr_no}</td>
          <td>{item.date_of_service}</td>
          <td>{item.admit_date}</td>
          <td>{item.discharge_date}</td>
          <td>{item?.id ?? "-"}</td>
        </tr>
      );
    });
  }

  function resetValues() {
    setLoadingState(false);
    setShowModalBox(false);
    setIsExcelUpload(false);
    setShowPreviewModalBox(false);
    updateExcelSheetData([]);
  }

  async function saveNewChartsInDB(e) {
    e.preventDefault();
    try {
      setLoadingState(true);
      const excelSheetDataToUpload = identifyNewChartsFromExistingCharts(
        oldVol,
        excelSheetData,
      );
      const data = {
        worklistId: worklistDetail?.id,
        excelSheetData: excelSheetDataToUpload || [],
      };

      const response = await saveNewPreviewChartsInDB(data, worklistDetail?.id);

      if (response?.success === true) {
        window.toastr.success("Worklist volume edited successfully");
        onSuccess();
        resetValues();
      } else {
        resetValues();
        window.toastr.error(response?.message || "Something went wrong!");
      }
    } catch (e) {
      console.log(e);
      window.toastr.error(e.message || "Something went wrong!!");
      resetValues();
    }
  }

  return (
    <>
      <div
        className="d-flex justify-content-start"
        data-kt-user-table-toolbar="base"
      >
        <button
          type="button"
          className="btn btn-primary"
          onClick={(e) => {
            setShowModalBox(true);
          }}
        >
          <i className="fas fa-edit"></i>
          Edit Worklist
        </button>
      </div>
      <Container>
        <Modal show={showModalBox} size="lg" centered>
          <div>
            <div>
              <Modal.Header className="modal-header py-4">
                <h2 className="fw-bold">Edit Worklist</h2>
                <Modal.Title
                  className="btn btn-icon btn-sm btn-active-icon-primary"
                  onClick={(e) => {
                    setShowModalBox(false);
                    setIsExcelUpload(false);
                    updateExcelSheetData([]);
                  }}
                >
                  <span className="svg-icon svg-icon-1">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        opacity="0.5"
                        x="6"
                        y="17.3137"
                        width="16"
                        height="2"
                        rx="1"
                        transform="rotate(-45 6 17.3137)"
                        fill="currentColor"
                      />
                      <rect
                        x="7.41422"
                        y="6"
                        width="16"
                        height="2"
                        rx="1"
                        transform="rotate(45 7.41422 6)"
                        fill="currentColor"
                      />
                    </svg>
                  </span>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body
                className="modal-body scroll-y my-5"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {!isLoaded ? (
                  <div className="flex row justify-center items-center min-h-screen">
                    <span className="spinner-border flex justify-center items-center h-10 w-10 text-gray-400"></span>
                  </div>
                ) : (
                  <form
                    onSubmit={
                      isExcelUpload ? handlePreview : handleSubmitPreview
                    }
                  >
                    <div className="row mb-4">
                      <div className="col-4">
                        <label className="form-label">Worklist #</label>
                        <input
                          className="form-control"
                          type="text"
                          name="worklist_no"
                          placeholder=""
                          defaultValue={worklistDetail?.worklist_no}
                          {...register(
                            "worklist_no",
                            registerOptions.worklist_no,
                          )}
                        />
                        <small className="text-danger">
                          {errors?.worklist_no && errors.worklist_no.message}
                        </small>
                      </div>
                      <div className="col-4">
                        <label className="form-label">
                          Primary Speciality{" "}
                        </label>
                        <select
                          className="form-select mb-2"
                          data-hide-search="true"
                          name="SpecialtyId"
                          defaultValue={desiredSpeciality?.id}
                          {...register(
                            "SpecialtyId",
                            registerOptions.SpecialtyId,
                          )}
                        >
                          <option value="">---</option>
                          {selectSpecialtyId?.map((option) => (
                            <option key={option.id} value={option.id}>
                              {option.name}
                            </option>
                          ))}
                        </select>
                        <small className="text-danger">
                          {errors?.SpecialtyId && errors.SpecialtyId.message}
                        </small>
                      </div>
                      <div className="col-4">
                        <label className="form-label">
                          <span>Received Date</span>
                        </label>
                        <Controller
                          name="received_date"
                          control={control}
                          defaultValue=""
                          render={({ field: { onChange, ...fieldProps } }) => (
                            <Flatpickr
                              options={options}
                              defaultValue={worklistDetail?.received_date}
                              onChange={(dates, currentdateString) =>
                                onChange(currentdateString)
                              }
                              className="form-control"
                              placeholder=""
                              name="received_date"
                            />
                          )}
                          rules={{
                            required: "Required",
                            validate: () => {
                              return (
                                moment(getValues("date_of_service")) <=
                                  moment(getValues("received_date")) ||
                                "Received date should be equal to or greater than the Date of service"
                              );
                            },
                          }}
                        />
                        <small className="text-danger">
                          {errors?.received_date &&
                            errors.received_date.message}
                        </small>
                      </div>
                    </div>
                    <div className="row mb-4">
                      {/* <div className="col-lg-4">
                        <label className="form-label">
                          <span>
                            Date of service
                            <OverlayTrigger
                              placement={"top"}
                              overlay={
                                <Tooltip id="tooltip-right">
                                  With worklists containing charts with multiple
                                  dates of service, this field will update all
                                  the charts to single date of service.
                                </Tooltip>
                              }
                            >
                              <i className="fas fa-exclamation-circle ms-2" />
                            </OverlayTrigger>
                          </span>
                        </label>
                        <Controller
                          name="date_of_service"
                          control={control}
                          defaultValue=""
                          render={({ field: { onChange, ...fieldProps } }) => (
                            <Flatpickr
                              options={optionsDS}
                              onChange={(dates, currentdateString) =>
                                onChange(currentdateString)
                              }
                              defaultValue={worklistDetail?.date_of_service}
                              className="form-control"
                              placeholder=""
                              name="date_of_service"
                            />
                          )}
                          rules={{ required: "Required" }}
                        />
                        <small className="text-danger">
                          {errors?.date_of_service &&
                            errors.date_of_service.message}
                        </small>
                      </div> */}
                      <div className="col-lg-4">
                        <label className="form-label">No. of Charts</label>
                        <input
                          className="form-control"
                          name="no_of_charts"
                          placeholder=""
                          defaultValue={worklistDetail?.no_of_charts}
                          {...register(
                            "no_of_charts",
                            registerOptions.no_of_charts,
                          )}
                        />
                        <small className="text-danger">
                          {errors?.no_of_charts && errors.no_of_charts.message}
                        </small>
                      </div>

                      <div className="row mb-2">
                        <div className="col-12 text-center text-warning fs-4 mt-2">
                          OR
                        </div>
                        <div className="col-12">
                          <label className="form-label">Excel File </label>
                          <input
                            className="form-control"
                            name="WorklistData"
                            type="file"
                            accept=".csv, .xlx, .xlsx, .xlt"
                            placeholder=""
                            {...register(
                              "WorklistData",
                              registerOptions.WorklistData,
                            )}
                            onInput={handleFileUpload}
                          />
                          <small className="text-danger">
                            {errors?.WorklistData &&
                              errors.WorklistData.message}
                          </small>
                          <div className="my-3">
                            <small className="text-muted">
                              <i class="bi bi-info-circle"></i> To add a
                              worklist without a file, please populate all
                              fields. To add a worklist with a file, please
                              populate all fields except date of service and no.
                              of charts as they will not be considered.
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mb-4"></div>
                    <div className="text-center pt-8">
                      <button
                        type="reset"
                        className="btn btn-light me-3"
                        data-kt-users-modal-action="cancel"
                        onClick={(e) => {
                          setShowModalBox(false);
                          setIsExcelUpload(false);
                          updateExcelSheetData([]);
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn btn-primary me-4"
                        disabled={isLoading}
                      >
                        <span className="indicator-label">
                          {isLoading
                            ? "Please wait..."
                            : isExcelUpload
                            ? "Preview"
                            : "Save"}
                        </span>
                      </button>
                    </div>
                  </form>
                )}
              </Modal.Body>
            </div>
          </div>
        </Modal>
      </Container>
      <Container>
        <Modal show={showPreviewModalBox} size="lg" centered>
          <div>
            <div>
              <Modal.Header className="modal-header py-4">
                <h2 className="fw-bold">Volume Preview</h2>
                <Modal.Title
                  className="btn btn-icon btn-sm btn-active-icon-primary"
                  onClick={(e) => {
                    setShowPreviewModalBox(false);
                    setIsExcelUpload(false);
                    updateExcelSheetData([]);
                  }}
                >
                  <span className="svg-icon svg-icon-1">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        opacity="0.5"
                        x="6"
                        y="17.3137"
                        width="16"
                        height="2"
                        rx="1"
                        transform="rotate(-45 6 17.3137)"
                        fill="currentColor"
                      />
                      <rect
                        x="7.41422"
                        y="6"
                        width="16"
                        height="2"
                        rx="1"
                        transform="rotate(45 7.41422 6)"
                        fill="currentColor"
                      />
                    </svg>
                  </span>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body className="modal-body scroll-y my-5">
                {!isLoaded ? (
                  <div className="flex row justify-center items-center min-h-screen">
                    <span className="spinner-border flex justify-center items-center h-10 w-10 text-gray-400"></span>
                  </div>
                ) : (
                  <form>
                    <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                      <table className="table align-middle table-row-dashed fs-5 gy-5 px-2">
                        <thead>
                          <tr className="text-start text-dark fw-bold fs-7 text-uppercase gs-0">
                            <th>Chart Number #</th>
                            <th>MRN</th>
                            <th>Date of Service</th>
                            <th>Admit Date</th>
                            <th>Discharge Date</th>
                            <th>Existing Chart ID</th>
                          </tr>
                        </thead>
                        <tbody className="text-gray-600 fw-semibold w-100 align-middle text-center">
                          {renderUploadedChartListViewList(
                            oldVol,
                            excelSheetData,
                          )}
                        </tbody>
                      </table>
                    </div>
                    <div className="row mb-4"></div>
                    <span>
                      Note: Please click “Save” if you wish to add the charts
                      highlighted in Green to the worklist. All other charts
                      that are not highlighted have been deemed as existing or
                      older charts.
                    </span>
                    <div className="text-center pt-8">
                      <button
                        type="reset"
                        className="btn btn-light me-3"
                        data-kt-users-modal-action="cancel"
                        onClick={(e) => {
                          setShowPreviewModalBox(false);
                          setIsExcelUpload(false);
                          updateExcelSheetData([]);
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn btn-primary me-4"
                        disabled={isLoading}
                        onClick={saveNewChartsInDB}
                      >
                        <span className="indicator-label">
                          {isLoading ? "Please wait..." : "Save"}
                        </span>
                      </button>
                    </div>
                  </form>
                )}
              </Modal.Body>
            </div>
          </div>
        </Modal>
      </Container>
    </>
  );
};

export default WorklistEditVol;
